import React, { useState } from "react";
import { VStack, HStack, Text } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

const Calendar = ({
  getAvailableSlotsForDay,
  selectedDate,
  setSelectedDate,
  calendarDate,
  maxGlobalDate,
}) => {
  const [calendarError, setCalendarError] = useState(false);
  const calendarDayStyle = {
    w: "13.2%",
    h: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    fontSize: "14px",
    lineHeight: "24px",
    fontFamily: "Nunito",
  };
  const location = useLocation();
  const today = new Date();
  const year = calendarDate.getFullYear();
  const month = calendarDate.getMonth() + 1;

  function getDaysForMonth() {
    const daysInMonth = new Date(year, month, 0).getDate();
    const firstDayOfMonth = new Date(year, month - 1, 1).getDay();
    const adjustedFirstDay = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;

    let monthData = [];

    let week = new Array(adjustedFirstDay).fill(null);

    for (let i = 1; i <= daysInMonth; i++) {
      week.push({
        day: i,
        date: new Date(year, month - 1, i),
      });
      if (week.length === 7) {
        monthData.push(week);
        week = [];
      }
    }
    if (week.length > 0) {
      while (week.length < 7) {
        week.push(null);
      }
      monthData.push(week);
    }
    return monthData;
  }

  function isDateGreaterThanMaxDate(date) {
    try {
      let maxDate = null;
      if (location?.state?.globalMaxDate) {
        maxDate = new Date(location.state.globalMaxDate);
      } else {
        maxDate = new Date(maxGlobalDate);
      }
      if (!maxDate || isNaN(maxDate.getTime())) {
        setCalendarError(true);
        return false;
      }
      return date > maxDate;
    } catch (error) {
      setCalendarError(true);
      console.error("Error computing maxDate:", error);
      return false;
    }
  }

  if (calendarError) {
    return <Text>Calendar is currently unavailable.</Text>;
  }

  return (
    <VStack width={"100%"} spacing={"1.26%"}>
      {getDaysForMonth().map((week, weekIndex) => (
        <HStack key={weekIndex} width={"100%"} spacing={"1.26%"}>
          {week.map((day, dayIndex) => {
            if (!day) {
              return <Text key={dayIndex} {...calendarDayStyle}></Text>; // Render an empty slot
            }
            const isPastDate = day.date <= today;
            const noSlots = getAvailableSlotsForDay(day.day) === 0;
            const isFarFutureDate = isDateGreaterThanMaxDate(day.date);

            return (
              <Text
                key={dayIndex}
                _hover={{
                  color:
                    isPastDate || noSlots || isFarFutureDate
                      ? undefined
                      : "#FFFFFF",
                  backgroundColor:
                    isPastDate || noSlots || isFarFutureDate
                      ? undefined
                      : "#0E3665",
                  cursor:
                    isPastDate || noSlots || isFarFutureDate
                      ? "default"
                      : "pointer",
                }}
                color={
                  selectedDate &&
                  day.date.toDateString() === selectedDate.toDateString()
                    ? "#FFFFFF"
                    : "#088041"
                }
                backgroundColor={
                  selectedDate &&
                  day.date.toDateString() === selectedDate.toDateString()
                    ? "#0E3665"
                    : isPastDate || noSlots || isFarFutureDate
                    ? "#eceff9"
                    : "rgba(13, 227, 115, 0.1)"
                }
                {...calendarDayStyle}
                onClick={() => {
                  if (!isPastDate && !noSlots && !isFarFutureDate) {
                    setSelectedDate(day.date);
                  }
                }}
              >
                {day.day}
              </Text>
            );
          })}
        </HStack>
      ))}
    </VStack>
  );
};

export default Calendar;
